import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { History } from "@mui/icons-material";

import { LargeContentBox } from "../../components/common";
import { ScreenMobile } from "../../components/common/ScreenMobile";
import { PageHeader } from "@/components/common/PageHeader";
import { AccessHistoryContent } from "./AccessHistoryContent";

export function AccessHistory() {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home");
    }
  };

  if (isMobileLayout) {
    return (
      <ScreenMobile
        title="Histórico de acessos"
        open={open}
        onClose={handleClose}
      >
        <AccessHistoryContent variant="preview" />
      </ScreenMobile>
    );
  }

  return (
    <LargeContentBox>
      <Stack
        width="100%"
        spacing={3}
        sx={{
          overflow: "auto",
          maxWidth: "100%",
        }}
      >
        <PageHeader
          title="Histórico de acessos"
          icon={History}
          description="Veja quem acessou seus registros de saúde"
        />
        <AccessHistoryContent variant="full" />
      </Stack>
    </LargeContentBox>
  );
}
